import { render, staticRenderFns } from "./ActionMealFavorite.vue?vue&type=template&id=6dfc970c&scoped=true"
import script from "./ActionMealFavorite.vue?vue&type=script&lang=js"
export * from "./ActionMealFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc970c",
  null
  
)

export default component.exports